export { ResponsiveContext } from './ResponsiveContext';


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet/es6/contexts/ResponsiveContext/index.js
// module id = 352
// module chunks = 0